import { makeStyles } from '@mui/styles';
import clsx from 'clsx';
import * as React from 'react';

import DeleteButton from '../components/DeleteButton';
import ImageActionButton from '../components/ImageActionButton';
import images from '../components/images';
import { ContextStore } from '../store/contextStore';

const imageSize = 50;

const useUploadImageStyles = makeStyles((theme) => ({
    root: {
        cursor: 'pointer',
        position: 'relative',
        marginBottom: theme.spacing(2),
        display: 'flex',
        gap: '1rem',
        alignItems: 'center',
    },
    image: {
        border: '1px solid transparent',
        borderRadius: '90px',
        opacity: 0.7,
        '&:hover': {
            opacity: 1.0,
        },
    },
    imageError: {
        borderColor: theme.palette.secondary.main,
    },
    upload: {
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center center',
    },
    existing: {
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center center',
    },
    placeholder: {
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center center',
    },
    // label: {
    //     position: 'absolute',
    //     right: '-250px',
    //     bottom: '10px',
    // },
    helperText: {
        color: theme.palette.secondary.main,
        marginTop: theme.spacing(1),
    },
}));

const UploadAvatarImage = (props) => {
    const { settings } = React.useContext(ContextStore);
    const classes = useUploadImageStyles();
    const PLACEHOLDER_FILE = '/profile.png';
    const preset = 'cover_350x250';
    const TYPE_DEFAULT = 0; // image placeholder
    const TYPE_EXISTING = 1; // existing image preview
    const TYPE_UPLOAD = 2; // upload preview
    const type = props.isUpload && props.image ? TYPE_UPLOAD : props.image ? TYPE_EXISTING : TYPE_DEFAULT;

    const imageUrl = type === TYPE_UPLOAD ? URL.createObjectURL(props.image) : type === TYPE_EXISTING ? images.url(settings.images.base, props.image, preset) : null;
    const imageWidth = props.width || imageSize;
    const imageHeight = props.height || imageSize;
    const borderRadius = props.borderRadius || Math.round(Math.min(imageWidth, imageHeight) / 2);

    const bgImage = {
        backgroundImage: `url(${imageUrl})`,
        height: `${imageHeight}px`,
        width: `${imageWidth}px`,
        borderRadius: borderRadius,
        ...props.imageStyle,
    };
    const placeholderImage = {
        backgroundImage: `url(${process.env.PUBLIC_URL}${PLACEHOLDER_FILE})`,
        height: `${imageHeight}px`,
        width: `${imageWidth}px`,
        borderRadius: borderRadius,
        ...props.placeholderStyle,
    };

    const rootStyle = props.rootStyle || {};

    return (
        <div className={classes.root} style={rootStyle}>
            {type === TYPE_UPLOAD ? <div onClick={props.disabled ? undefined : props.onClick} className={clsx(classes.image, classes.upload, props.error && classes.imageError)} style={bgImage} /> : null}
            {type === TYPE_EXISTING ? <div onClick={props.disabled ? undefined : props.onClick} className={clsx(classes.image, classes.existing, props.error && classes.imageError)} style={bgImage} /> : null}
            {type === TYPE_DEFAULT ? <div onClick={props.disabled ? undefined : props.onClick} className={clsx(classes.image, classes.placeholder, props.error && classes.imageError)} style={placeholderImage}></div> : null}
            {/* CP-5556: [UPLOAD IMAGE] until there is one, then [DELETE] + [REPLACE IMAGE] ("image", never "picture");
                delete sits left of the other action, as in FormActionButtons. */}
            <div style={{ display: 'flex', justifyContent: 'space-between', gap: '1rem' }}>
                {props.image ? <DeleteButton disabled={props.disabled} onClick={props.onDelete} /> : null}
                <ImageActionButton hasImage={Boolean(props.image)} disabled={props.disabled} onClick={props.onClick} />
            </div>

            {props.helperText ? (
                <div onClick={props.onClick} className={classes.helperText}>
                    {props.helperText}
                </div>
            ) : null}
        </div>
    );
};

export default React.memo(UploadAvatarImage);
